import type { FC, ReactNode } from "react";
import { Fragment } from "react";
import Rank from "../atom/rank";
import Time from "../atom/time";
import Title from "../atom/title";

type Props = {
  rank: ReactNode;
  title: ReactNode;
  subTitle: ReactNode;
  time: ReactNode;
};

export const Content1: FC<Props> = (props) => {
  const { rank, title, subTitle, time } = props;

  return (
    <Fragment>
      <Rank>{rank}</Rank>
      <Title>{title}</Title>
      <Title>{subTitle}</Title>
      <Time>{time}</Time>
    </Fragment>
  );
};
